import { createIcons, icons } from 'lucide';

// Initialize all Lucide icons when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  createIcons({
    icons: icons,
    attrs: {
      'stroke-width': 1.5,
    },
  });
});

// Re-initialize icons after Turbo Drive navigation
document.addEventListener('turbo:render', () => {
  createIcons({
    icons: icons,
    attrs: {
      'stroke-width': 1.5,
    },
  });
}); 